export const COOKIE_CONSENT_CLIENT_ID = "2544";
export const COOKIE_CONSENT_DOMAIN_ID =
	"efde9aff-f67d-4caa-a1a1-ae55edce7ef0";

/** ID no formato `{clientId}/{domainId}` — usar só no GTM se o Passo 1 não for instalado. */
export const COOKIE_CONSENT_ID = `${COOKIE_CONSENT_CLIENT_ID}/${COOKIE_CONSENT_DOMAIN_ID}`;

export const COOKIE_CONSENT_SCRIPT_URL = `https://cdn-api-cmp.becompliance.com/client-side/${COOKIE_CONSENT_ID}.js`;

export const COOKIE_CONSENT_COOKIE_NAME = "BeAliantConsent";
export const COOKIE_POLICY_PATH = "/cookies";

/** Botão estático no HTML inicial — o CMP só escuta `data-cc` nos elementos presentes na carga. */
export const COOKIE_PREFERENCES_TRIGGER_ID =
	"cookie-consent-preferences-trigger";
